<template>
  <div
    class="close-website"
    @click="handleCloseWebsite"
  >
    <img src="@/assets/close.svg">
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import useWebsitePlugin from '@/composables/useWebsitePlugin';
import useActions from '@/composables/useActions';

export default defineComponent({
  name: 'CloseWebsiteButtonComponent',

  emits: ['close'],

  props: {
    isContentElement: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    const { currentAction } = useActions();
    const { handleClose } = useWebsitePlugin();

    function handleCloseWebsite() {
      if (!props.isContentElement) {
        emit('close');
      } else {
        handleClose();
      }
    }

    return {
      currentAction,
      handleCloseWebsite,
    };
  },
});
</script>

<style lang="scss" scoped>
.close-website {
  position: fixed;
  top: 13px;
  right: 16px;
  height: 38px;
  width: 38px;
  border-radius: 100%;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(30px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 42;

  @media screen and (min-width: $tablet_breakpoint) {
    top: 10px;
    height: 48px;
    width: 48px;
  }

  @media screen and (min-width: $desktop_l_breakpoint) {
    img {
      width: 60%;
      height: 60%;
    }
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    width: 140px;
    height: 140px;
    right: 40px;
    top: 20px;
  }
}
</style>
